if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.mobileMql = window.matchMedia('(max-width: 749px)');
      if (!this.elements.viewer) return;

      this.initMobileSingleVideo();
      this.elements.viewer.addEventListener('slideChanged', this.onSlideChanged.bind(this));
      this.initProductVideoSliderScroll();
      if (this.elements.thumbnails) {
        this.elements.thumbnails.addEventListener('click', this.onThumbnailClick.bind(this));
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }
      this.initProductVideoViewport();
      this.initVideoMutationObserver();
    }

    onThumbnailClick(event) {
      var target = event.target.closest('[data-target]');
      if (!target) return;
      var button = target.querySelector('button');
      if (!button || !button.contains(event.target)) return;
      event.preventDefault();
      var mediaId = target.getAttribute('data-target');
      if (mediaId) this.setActiveMedia(mediaId, false);
    }

    onSlideChanged(event) {
      const currentSlide = event.detail && event.detail.currentElement;
      if (!currentSlide || !currentSlide.dataset.mediaId) return;
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));
      currentSlide.classList.add('is-active');
      this.playActiveMedia(currentSlide);
      if (this.elements.thumbnails) {
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ currentSlide.dataset.mediaId }"]`);
        this.setActiveThumbnail(thumbnail);
        if (thumbnail) this.announceLiveRegion(currentSlide, thumbnail.dataset.mediaPosition);
      }
    }

    setActiveMedia(mediaId, prepend) {
      var slides = this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]');
      var activeMedia = null;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === mediaId) {
          activeMedia = slides[i];
          break;
        }
      }
      if (!activeMedia) return;
      var activeThumbnail = null;
      if (this.elements.thumbnails) {
        var thumbItems = this.elements.thumbnails.querySelectorAll('[data-target]');
        for (var t = 0; t < thumbItems.length; t++) {
          if (thumbItems[t].getAttribute('data-target') === mediaId) {
            activeThumbnail = thumbItems[t];
            break;
          }
        }
      }
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach(function(el) {
        el.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (activeThumbnail) activeThumbnail.parentElement.prepend(activeThumbnail);
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      var self = this;
      window.setTimeout(function() {
        var parent = activeMedia.parentElement;
        if (parent && parent.scrollTo) parent.scrollTo({ left: activeMedia.offsetLeft });
        if (!self.elements.thumbnails || self.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({ behavior: 'smooth' });
        }
      }, 0);
      this.playActiveMedia(activeMedia);
      if (this._lastActiveSlide !== undefined) this._lastActiveSlide = activeMedia;

      if (activeThumbnail) {
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.getAttribute('data-media-position') || '');
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      if (!activeItem) return;
      var w = typeof window !== 'undefined' ? window.innerWidth : 0;
      var isDesktop = w >= 750;
      var videoSrc = activeItem.getAttribute('data-video-src');
      if (!isDesktop && videoSrc && this._mobileVideoWrap) {
        this.cleanupMobileVideo();
        this._desktopPlayingSlide = activeItem;
        this.playActiveMediaMobile(activeItem);
        return;
      }
      if (isDesktop) {
        this.cleanupMobileVideo();
        this._desktopPlayingSlide = activeItem;
        window.pauseAllMedia();
        var deferredMedia = activeItem.querySelector('deferred-media, .deferred-media');
        if (deferredMedia) {
          deferredMedia.loadContent(false);
          if (deferredMedia.playMedia) deferredMedia.playMedia();
          this._playDesktopVideoWhenReady(deferredMedia);
        }
        return;
      }
      if (this._mobileVideoWrap) {
        this.playActiveMediaMobile(activeItem);
        return;
      }
      window.pauseAllMedia();
      var deferredMedia = activeItem.querySelector('deferred-media, .deferred-media');
      if (deferredMedia) {
        deferredMedia.loadContent(false);
        if (deferredMedia.playMedia) deferredMedia.playMedia();
      }
    }

    _playDesktopVideoWhenReady(deferredMedia) {
      var video = deferredMedia ? deferredMedia.querySelector('video') : null;
      if (!video) return;
      video.muted = true;
      video.loop = true;
      video.controls = false;
      function doPlay() {
        video.play().catch(function() {});
      }
      if (video.readyState >= 2) {
        requestAnimationFrame(doPlay);
        return;
      }
      video.addEventListener('canplay', doPlay, { once: true });
      video.addEventListener('loadeddata', doPlay, { once: true });
      requestAnimationFrame(function() {
        requestAnimationFrame(doPlay);
      });
    }

    cleanupMobileVideo() {
      if (this._mobileVideoCurrentSlide) {
        this._mobileVideoCurrentSlide.classList.remove('product__media-item--mobile-video-active');
        this._mobileVideoCurrentSlide = null;
      }
      if (this._mobileVideoWrap && this._mobileVideoWrap.parentNode) {
        this._mobileVideoWrap.parentNode.removeChild(this._mobileVideoWrap);
      }
      if (this._mobileVideo) this._mobileVideo.pause();
    }

    playActiveMediaMobile(activeItem) {
      var videoSrc = activeItem ? activeItem.getAttribute('data-video-src') : null;
      var wrap = this._mobileVideoWrap;
      var video = this._mobileVideo;
      var prevSlide = this._mobileVideoCurrentSlide;

      if (prevSlide) {
        prevSlide.classList.remove('product__media-item--mobile-video-active');
        if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
      }
      this._mobileVideoCurrentSlide = null;

      if (video) video.pause();

      if (videoSrc && activeItem && wrap && video) {
        activeItem.classList.add('product__media-item--mobile-video-active');
        activeItem.appendChild(wrap);
        this._mobileVideoCurrentSlide = activeItem;
        video.muted = true;
        video.loop = true;
        video.setAttribute('playsinline', '');
        video.controls = false;
        video.src = videoSrc;
        video.load();
        var doPlay = function() {
          video.play().catch(function() {});
        };
        if (video.readyState >= 2) {
          requestAnimationFrame(function() { requestAnimationFrame(doPlay); });
        } else {
          video.addEventListener('canplay', doPlay, { once: true });
          video.addEventListener('loadeddata', doPlay, { once: true });
          video.addEventListener('loadedmetadata', doPlay, { once: true });
        }
        setTimeout(doPlay, 100);
        setTimeout(doPlay, 400);
      }
    }

    initMobileSingleVideo() {
      if (this._mobileVideoWrap) return;
      var wrap = document.createElement('div');
      wrap.className = 'product__mobile-video-wrap';
      var video = document.createElement('video');
      video.setAttribute('playsinline', '');
      video.muted = true;
      video.loop = true;
      video.controls = false;
      wrap.appendChild(video);
      this._mobileVideoWrap = wrap;
      this._mobileVideo = video;
      this._mobileVideoCurrentSlide = null;
    }

    initProductVideoViewport() {
      if (!this.elements.viewer || typeof IntersectionObserver === 'undefined') return;
      var w = typeof window !== 'undefined' ? window.innerWidth : 9999;
      if (w < 750) return;
      const slider = this.elements.viewer.querySelector('[id^="Slider-"]');
      if (!slider) return;
      const slides = this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]');
      const self = this;
      this._visibleRatios = this._visibleRatios || new Map();
      const observerCallback = function(entries) {
        entries.forEach(function(entry) {
          self._visibleRatios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
        });
        var bestSlide = null;
        var bestRatio = 0.25;
        self._visibleRatios.forEach(function(ratio, slide) {
          if (ratio >= bestRatio && slide.querySelector('.deferred-media')) {
            bestRatio = ratio;
            bestSlide = slide;
          }
        });
        if (bestSlide && bestSlide === self._desktopPlayingSlide) return;
        self._desktopPlayingSlide = bestSlide;
        slides.forEach(function(slide) {
          if (slide !== bestSlide && typeof window.pauseMediaInElement === 'function') {
            window.pauseMediaInElement(slide);
          }
        });
        if (bestSlide) self.playActiveMedia(bestSlide);
      };
      var observerOptions = {
        root: slider,
        rootMargin: '0px',
        threshold: [0, 0.25, 0.5, 0.75, 1]
      };
      this._videoObserver = new IntersectionObserver(function(entries) {
        requestAnimationFrame(function() {
          observerCallback(entries);
        });
      }, observerOptions);
      slides.forEach(function(slide) {
        if (slide.querySelector('.deferred-media')) {
          self._visibleRatios.set(slide, 0);
          self._videoObserver.observe(slide);
        }
      });
    }

    initProductVideoSliderScroll() {
      if (!this.elements.viewer) return;
      const slider = this.elements.viewer.querySelector('[id^="Slider-"]');
      if (!slider) return;
      const slides = Array.from(this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]'));
      const self = this;
      self._lastActiveSlide = null;
      var scrollTicking = false;
      function getVisibleSlide() {
        var scrollLeft = slider.scrollLeft;
        var sliderWidth = slider.clientWidth;
        if (!sliderWidth) return null;
        var center = scrollLeft + sliderWidth / 2;
        var best = null;
        var bestDist = Infinity;
        slides.forEach(function(slide) {
          var slideLeft = slide.offsetLeft;
          var slideWidth = slide.offsetWidth;
          var slideCenter = slideLeft + slideWidth / 2;
          var dist = Math.abs(center - slideCenter);
          if (dist < bestDist) {
            bestDist = dist;
            best = slide;
          }
        });
        return best;
      }
      function onSliderScroll() {
        if (scrollTicking) return;
        scrollTicking = true;
        requestAnimationFrame(function() {
          scrollTicking = false;
          var active = getVisibleSlide();
          if (active && active !== self._lastActiveSlide) {
            self._lastActiveSlide = active;
            self.elements.viewer.querySelectorAll('[data-media-id]').forEach(function(el) { el.classList.remove('is-active'); });
            active.classList.add('is-active');
            self.playActiveMedia(active);
          }
        });
      }
      slider.addEventListener('scroll', onSliderScroll, { passive: true });
      function syncVisibleSlide() {
        var active = getVisibleSlide();
        if (active && active !== self._lastActiveSlide) {
          self._lastActiveSlide = active;
          self.elements.viewer.querySelectorAll('[data-media-id]').forEach(function(el) { el.classList.remove('is-active'); });
          active.classList.add('is-active');
          self.playActiveMedia(active);
        }
      }
      setTimeout(syncVisibleSlide, 100);
      setTimeout(syncVisibleSlide, 500);
      if (typeof window !== 'undefined' && window.addEventListener) {
        window.addEventListener('load', syncVisibleSlide);
      }
    }

    initVideoMutationObserver() {
      var self = this;
      if (!this.elements.viewer || typeof MutationObserver === 'undefined') return;

      function slideIsActive(slide) {
        if (!slide) return false;
        return slide.classList.contains('is-active') ||
          slide === self._desktopPlayingSlide ||
          slide === self._lastActiveSlide ||
          slide === self._mobileVideoCurrentSlide;
      }

      function tryPlayVideoInSlide(slide) {
        if (!slideIsActive(slide)) return;
        var poster = slide.querySelector('.deferred-media__poster');
        if (poster) poster.style.setProperty('display', 'none');
        var video = slide.querySelector('video');
        if (!video) return;
        video.muted = true;
        video.loop = true;
        video.controls = false;
        video.setAttribute('playsinline', '');
        video.play().catch(function() {});
      }

      function processVideo(videoEl) {
        var slide = videoEl.closest('.product__media-item');
        if (!slide || !self.elements.viewer.contains(slide)) return;
        tryPlayVideoInSlide(slide);
      }

      var mo = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.tagName === 'VIDEO') {
              processVideo(node);
              continue;
            }
            if (node.querySelector) {
              var videos = node.querySelectorAll('video');
              for (var k = 0; k < videos.length; k++) processVideo(videos[k]);
            }
          }
        }
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].type !== 'attributes' || mutations[i].attributeName !== 'loaded') continue;
          var target = mutations[i].target;
          if (target.getAttribute && target.getAttribute('loaded')) {
            var slide = target.closest('.product__media-item');
            if (slide) {
              requestAnimationFrame(function() {
                tryPlayVideoInSlide(slide);
                var v = slide.querySelector('video');
                if (v) {
                  v.muted = true;
                  v.loop = true;
                  v.controls = false;
                  v.play().catch(function() {});
                }
              });
              setTimeout(function() {
                tryPlayVideoInSlide(slide);
                var v = slide.querySelector('video');
                if (v) v.play().catch(function() {});
              }, 50);
              setTimeout(function() {
                tryPlayVideoInSlide(slide);
                var v = slide.querySelector('video');
                if (v) v.play().catch(function() {});
              }, 200);
            }
          }
        }
      });

      mo.observe(this.elements.viewer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['loaded']
      });
      this._videoMutationObserver = mo;
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
